/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../theme';

export const WizardMultiSearchStyled = styled.div.attrs({
    className: 'wizard-multi-search',
})`
    margin-top: 32px;

    .wizard-multi-search__text_bold {
        ${fonts.textMainBold};
    }

    .wizard-multi-search__text_error {
        color: ${colors.textColorDanger};
    }

`;
